import { preferredViewModeState } from "@/context/states";
import theme from "@/styles/theme";
import ViewListIcon from "@mui/icons-material/ViewList";
import ViewModuleIcon from "@mui/icons-material/ViewModule";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import { useRecoilState } from "recoil";

export default function SwitchListGridButton() {
  const [preferredViewMode, setPreferredViewMode] = useRecoilState(
    preferredViewModeState,
  );

  const enableView = (type) => {
    setPreferredViewMode(type);
  };

  return (
    <Box sx={buttonStyles}>
      <IconButton
        aria-label="Listenansicht"
        onClick={() => enableView("list")}
        variant={preferredViewMode === "list" ? "active" : "inactive"}
      >
        <ViewListIcon />
      </IconButton>
      <IconButton
        aria-label="Kachelansicht"
        onClick={() => enableView("grid")}
        variant={preferredViewMode === "grid" ? "active" : "inactive"}
      >
        <ViewModuleIcon />
      </IconButton>
    </Box>
  );
}

const buttonStyles = {
  minHeight: "2.875rem",
  "& .MuiSvgIcon-root": {
    fontSize: 40,
  },
  "& .MuiButtonBase-root": {
    p: 0,
    borderRadius: "0",
  },
  [theme.breakpoints.up("sm")]: {
    transform: "translateY(0.125rem)",
  },
};
